<template>
  <div
    class="tw:flex-col tw:flex tw:w-full tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:mr-auto tw:ml-auto tw:min-h-screen-minus-header-and-footer"
  >
    <RIChannels />
  </div>
</template>

<script setup lang="ts">
import RIChannels from '@/components/rateInsights/RIChannels.vue'
</script>
